<template>
  <div>
    <p class="text-2xl">
      Inserir Saldo Whitelabel
    </p>
    <v-card>
      <v-form autocomplete="off">
        <validation-observer ref="rechargeWhitelabel">
          <v-card-text class="pa-3">
            <v-row>
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Whitelabel"
                  rules="required"
                  vid="whitelabelId"
                >
                  <v-autocomplete
                    v-model="whitelabelId"
                    :items="whitelabels"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    outlined
                    dense
                    item-text="value"
                    item-value="id"
                    label="Whitelabel"
                    @change="getSelectedWhitelabel"
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="2"
                sm="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Valor"
                  rules="required|validate_value:10"
                  vid="recharge.value"
                >
                  <v-text-field
                    v-model="recharge.value"
                    v-money="{
                      precision: 2,
                    }"
                    :error-messages="errors"
                    :hide-details="!errors.length"
                    outlined
                    dense
                    prefix="R$"
                    label="Valor (R$)"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn
              color="primary"
              class="pl-4"
              @click="rechargeWhitelabel"
            >
              Salvar
              <v-icon
                right
                dark
              >
                {{ icons.mdiFileCheck }}
              </v-icon>
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="pl-4"
              @click="resetForm"
            >
              Limpar
              <v-icon
                right
                dark
              >
                {{ icons.mdiCancel }}
              </v-icon>
            </v-btn>
          </v-card-actions>
        </validation-observer>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { mdiFileCheck, mdiCancel } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { mapActions } from 'vuex'

export default {
  setup() {
    const whitelabelId = ref(null)
    const whitelabels = ref([])
    const selectedWhitelabel = ref({})
    const recharge = ref({})

    return {
      whitelabels,
      whitelabelId,
      selectedWhitelabel,
      icons: {
        mdiFileCheck,
        mdiCancel,
      },
      recharge,
    }
  },

  async created() {
    await this.findWhitelabels()
  },

  methods: {
    ...mapActions('wallet', ['createWhitelabelRecharge']),

    resetForm() {
      this.whitelabelId = null
      this.selectedWhitelabel = {}
      this.recharge = {}
    },

    getSelectedWhitelabel() {
      const whitelabel = this.whitelabels.find(wl => wl.id === this.whitelabelId)

      if (whitelabel) {
        this.selectedWhitelabel = whitelabel
      }
    },

    async findWhitelabels() {
      // Dados fixos de whitelabels
      this.whitelabels = [
        {
          id: 'hlYE7Wp80sZZYdSY0z4moJ2egIhXZZp6KRsu',
          value: 'Betenvios',
        },
        {
          id: 'HZAY4LTEb8C8YqgAW5csO14mgepgw47f7WEa',
          value: 'Hands',
        },
        {
          id: 'BS9mK2qT7xP4vR8cL1nF5wH3yD6uZ0aE',
          value: 'Boostsend',
        },
        {
          id: 'OE1aLfs28HE1D1s25LDwr8A4SSZu2hqfmPWcx',
          value: 'Daxx',
        },
      ]
    },

    async rechargeWhitelabel() {
      if (await this.$refs.rechargeWhitelabel.validate()) {
        const response = await this.createWhitelabelRecharge({
          whitelabelId: this.whitelabelId,
          value: this.$strip(this.recharge.value),
        })

        if (response >= 200 && response < 300) {
          Vue.prototype.$toast?.success('Recarga whitelabel registrada com sucesso!')
          this.resetForm()
          return
        }

        const errorMessage = response?.response?.data?.message ?? 'Erro ao realizar recarga'
        Vue.prototype.$toast?.error(errorMessage)
      }
    },
  },
}
</script>

